import { Box, Text } from '@chakra-ui/react';
import { capitalCase } from 'change-case';

import { RegistryPackage } from '@/graphql/upbound-graphql';

const PackageType: React.FC<{ data: RegistryPackage }> = ({ data }) => {
  return (
    <Box
      mr={{ base: '0', xl: '65px' }}
      mb={{ base: '20px', xl: '0' }}
      pb={{ base: '20px', xl: '0' }}
      borderBottom={{ base: '1px solid', xl: 'none' }}
      borderBottomColor={{ base: 'white.4', xl: 'none' }}
    >
      <Text display="block" fontSize="14px" lineHeight="20px" color="black.0" fontWeight={900} mb="8px">
        Package Type
      </Text>
      <Text>{capitalCase(data.packageType)}</Text>
    </Box>
  );
};

export default PackageType;
